// extracted by mini-css-extract-plugin
export default {"overlay":"custom-popup_overlay__wT0PE","popup":"custom-popup_popup__VPdHe","close":"custom-popup_close__FjsYy","content":"custom-popup_content__u-ZFj"};